import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "sempresera-privacy-notice";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "acknowledged");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4"
          data-testid="cookie-consent-bar"
          role="region"
          aria-label="Privacy notice"
        >
          <div className="glass mx-auto flex max-w-3xl flex-col items-start gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs leading-relaxed text-[#C9D2DE]">
              We use privacy-respecting analytics to understand how this site is used — no advertising trackers, and
              we never sell your information. Details in our{" "}
              <Link to="/privacy" className="text-brand hover:underline" data-testid="cookie-privacy-link">
                Privacy Policy
              </Link>
              .
            </p>
            <button
              type="button"
              onClick={dismiss}
              className="btn-primary shrink-0 !px-5 !py-2"
              data-testid="cookie-accept-button"
            >
              Got it
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
